import React from 'react';

interface LoadingTextProps {
  message?: string;
  className?: string;
}

export const LoadingText: React.FC<LoadingTextProps> = ({ message = 'Loading...', className = '' }) => {
  return <div className={`text-center py-8 text-gray-500 ${className}`}>{message}</div>;
};
